import { render, staticRenderFns } from "./CalmButton.vue?vue&type=template&id=b09c7fea&"
import script from "./CalmButton.vue?vue&type=script&lang=js&"
export * from "./CalmButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports